import * as Sentry from "@sentry/browser";

const CHATBOT_IFRAME_SELECTOR = 'iframe#nm_chat_iframe';
const CHATBOT_CLASS_NAME_OPEN = 'nm_chat--open';
const CHATBOT_OPEN_LINK_SELECTOR = '[href="#open-chatbot"]';
const TRUSTED_SHOPS_BADGE_SELECTOR = '[id^="trustbadge-container"]';

/**
 * runtime variable to store Trusted Shops badge's z-index
 *
 * WHY: The Trusted Shops badge has the maximum possible value for z-index.
 *      To reliably put the chatbot window above the Trusted Shops badge,
 *      we have to change the z-index value of it.
 */
let trustedShopsBadgeZIndex: string = '';

/**
 * See: NEOS Project `neos/DistributionPackages/Louis.Site/Resources/Private/Fusion/Presentation/Component/Chatbot/`
 */
function init() {
    try {
        // don't initialize in Neos CMS backend
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        const iframeElement: HTMLIFrameElement | null = document.querySelector(CHATBOT_IFRAME_SELECTOR);
        if (iframeElement == null) {
            return;
        }

        const chatbotIframeSrc = iframeElement.dataset.src;
        const chatbotOrigin = (new URL(chatbotIframeSrc)).origin;

        iframeElement.src = chatbotIframeSrc;
        iframeElement.onload = () => {
            const louisReferer = window.location ? window.location.href : window.opener.location.href;

            iframeElement.contentWindow.postMessage(
                {
                    sender: "get_parent_url",
                    message: louisReferer,
                },
                chatbotOrigin
            );
        }

        window.addEventListener("message", createChatbotMsgHandler(chatbotOrigin));

        document.querySelectorAll(CHATBOT_OPEN_LINK_SELECTOR).forEach(link => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                iframeElement.contentWindow.postMessage(
                    "increaseNMiFrame",
                    chatbotOrigin,
                );
                event.stopPropagation();
            });
        });

        // unhide iframe after initialization
        iframeElement.style.display = "";
    } catch (e) {
        Sentry.captureException(e);
    }
}

function createChatbotMsgHandler(expectedMessageOrigin: string) {
    return function handleMessageFromChatbot(event: MessageEvent) {
        if (event.origin === expectedMessageOrigin) {
            switch (event.data) {
                case "increaseNMiFrame":
                    openChatbot();
                    break;
                case "decreaseNMiFrame":
                    closeChatbot();
                    break;
                default:
            }
        }
    }
}

function openChatbot() {
    // set Trusted Shops badge's z-index 1 below chatbot iframe
    const trustedShopsBadgeElement: HTMLElement | null = document.querySelector(TRUSTED_SHOPS_BADGE_SELECTOR);
    if (trustedShopsBadgeElement != null) {
        trustedShopsBadgeZIndex = trustedShopsBadgeElement.style.zIndex ?? '';
        trustedShopsBadgeElement.style.zIndex = '99999';
    }

    document.querySelector(CHATBOT_IFRAME_SELECTOR).classList.add(CHATBOT_CLASS_NAME_OPEN);
}

function closeChatbot() {
    // reset Trusted Shops badge's z-index
    const trustedShopsBadgeElement: HTMLElement | null = document.querySelector(TRUSTED_SHOPS_BADGE_SELECTOR);
    if (trustedShopsBadgeElement != null) {
        trustedShopsBadgeElement.style.zIndex = trustedShopsBadgeZIndex;
    }

    document.querySelector(CHATBOT_IFRAME_SELECTOR).classList.remove(CHATBOT_CLASS_NAME_OPEN);
}

export default {
    init,
}
